import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

/**
 * 店舗検索リクエストパラメータの型定義
 */
export interface ClubSearchParams {
  is_search_nearby: boolean; // 現在地からの検索
  region_code?: number; // エリアID
  club_name_or_address?: string; // 店舗名・住所
  tag_list?: number[]; // タグIDリスト (絞り込み条件となるタグ)
  member_id: string; // 会員番号
}

/**
 * お気に入り店舗登録リクエストパラメータの型定義
 */
export interface FavoriteClubParams {
  member_id: string; // 会員番号
  club_id: number; // 店舗ID
  is_favorite: boolean; // お気に入り登録フラグ (true: 登録, false: 取消)
}

/**
 * 予約(Reservation)関連のAPIサービス
 */
const reservationService = () => {
  return {
    /**
     * 店舗検索オプション取得
     * GET /api/mypage/yoyaku/club-options
     */
    getClubOptions: () => {
      return apiClient.get(`${API_BASE_ADDRESS}/mypage/yoyaku/club-options`);
    },

    /**
     * 店舗検索
     * POST /api/mypage/yoyaku/club
     */
    searchClubs: (params: ClubSearchParams) => {
      return apiClient.post(`${API_BASE_ADDRESS}/mypage/yoyaku/club`, params);
    },

    /**
     * お気に入り店舗登録・取消
     * POST /api/mypage/yoyaku/favorite-club
     */
    toggleFavoriteClub: (params: FavoriteClubParams) => {
      return apiClient.post(`${API_BASE_ADDRESS}/mypage/yoyaku/favorite-club`, params);
    },

    /**
     * 共通店舗リスト取得
     * GET /api/mypage/yoyaku/common-club-list
     */
    getCommonClubList: (memberId: string, clubId: number) => {
      return apiClient.get(`${API_BASE_ADDRESS}/mypage/yoyaku/common-club-list`, {
        params: {
          member_id: memberId,
          club_id: clubId,
        },
      });
    },
  };
};

export default reservationService;
